'use strict';

var GlobalNotificationsPanelController = function GlobalNotificationsPanelController($scope, $state, $timeout, systemConstants, globalNotificationsDataService, globalNotificationsConstants) {
  var DEFAULT_INTERVAL = 5;
  callForNotification();
  function updateGrid() {
    globalNotificationsDataService.getTotalAlertsNumber().then(updateGridData);
  }
  function updateGridData(globalNotifications) {
    if (globalNotifications > 0) {
      $scope.globalNotificationsHeader = '(' + 1 + ')';
      if ($scope.data.length < 1) {
        $scope.data.push({
          name: 'Host Share Available'
        });
      }
    }
  }
  function getInterval() {
    return DEFAULT_INTERVAL * 60000;
  }
  function callForNotification() {
    var interval = getInterval();
    $timeout(function () {
      updateGrid();
      $scope.$broadcast('brush-filter:filterApplied:updateToolbar');
      callForNotification();
    }, interval);
  }
  function updatePanelTitle() {
    var mapTitlePrefix = {};
    mapTitlePrefix[globalNotificationsConstants.GLOBAL_NOTIFACATION_TABS.GLOBAL] = globalNotificationsConstants.GLOBAL_NOTIFICATION_PANEL_TITLE_PREFIX.GLOBAL;
    mapTitlePrefix[globalNotificationsConstants.GLOBAL_NOTIFACATION_TABS.CATEGORY2] = globalNotificationsConstants.GLOBAL_NOTIFICATION_PANEL_TITLE_PREFIX.CATEGORY2;
    $scope.panelTitlePrefix = mapTitlePrefix[$scope.tab];
  }
  function switchGrid(newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.clearSelection(true);
      updatePanelTitle();
      updateGridData($scope.globalNotifications);
    }
  }
  function hasSelectedRows() {
    return $scope.gridSettings.jqxGrid('selectedrowindexes').length > 0;
  }
  $scope.tab = 'globalTab';
  $scope.modeList = [{
    label: 'Global',
    value: globalNotificationsConstants.GLOBAL_NOTIFACATION_TABS.GLOBAL
  }];
  $scope.gridId = 'global-notifications-grid';
  $scope.data = [];
  $scope.gridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    selectionmode: 'checkbox_multiplerowsadvanced',
    source: $scope.data,
    columns: [{
      text: 'Global Notifications',
      dataField: 'name',
      cellsalign: 'left',
      textalign: 'left'
    }]
  };
  $scope.navigateButtonVisible = true;
  $scope.panelOpened = false;
  $scope.rowSelectionChanged = function () {
    if ($scope.navigateButtonVisible !== hasSelectedRows()) {
      $scope.navigateButtonVisible = hasSelectedRows();
      $scope.$apply();
    }
  };
  $scope.resetGridPanel = function () {
    $scope.tab = globalNotificationsConstants.GLOBAL_NOTIFACATION_TABS.GLOBAL;
    updatePanelTitle();
    updateGrid();
  };
  $scope.clearSelection = function (silent) {
    if (silent !== true || hasSelectedRows()) {
      $scope.navigateButtonVisible = false;
      $scope.gridSettings.jqxGrid('clearselection');
    }
  };
  $scope.navigateWithTransitionDataToHstMkt = function () {
    if ($scope.tab === 'globalTab') {
      goToScreen('app.system-configuration');
    } else if ($scope.tab === 'category2Tab') {
      goToScreen('app.system-configuration');
    }
  };
  function goToScreen(screenPath) {
    $scope.hidePanel();
    $state.go(screenPath, {
      transitionData: {
        skipSearch: true,
        'system-configuration:force-tab': {
          tabId: systemConstants.SCREEN_VALUE.SYSTEM_CONFIG.HOST_SHARE
        }
      }
    });
  }
  $scope.$watch('tab', switchGrid);
};
GlobalNotificationsPanelController.$inject = ['$scope', '$state', '$timeout', 'SystemConstants', 'GlobalNotificationsDataService', 'GlobalNotificationsConstants'];
module.exports = GlobalNotificationsPanelController;